module.exports = __webpack_public_path__ + "img/phlebio_send_inactive.06c925e4.svg";